import React from 'react'
import { Link } from 'react-router-dom';
import Product from './Product'
import { HomePath } from '../home-path'

export default function Brands({products}) {

    let athletix = products?.filter(product => product?.brand == 'athletix');
    let jordan = products?.filter(product => product?.brand == 'jordan');
    let adidas = products?.filter(product => product?.brand == 'adidas');
    let champion = products?.filter(product => product?.brand == 'puma');
    let asics = products?.filter(product => product?.brand == 'asics');
  return (
    <section className="w-full h-fit py-12">
        <div className="mxw">
            {/* section heaing */}
            <div className="w-full h-fit py-4 text-left">
                <p className="text-2xl md:text-3xl font-semibold">Shop by brand</p>
            </div>
        </div>
        {/* <div className="mxw grid overflow-auto scrollbar-hide grid-flow-col-dense md:grid-cols-3 py-12 gap-2 md:gap-4"> */}
        <div className="mxw grid overflow-auto scrollbar-hide grid-flow-col-dense auto-cols-auto py-12 gap-2 md:gap-4">
            {/* asics */}
            <Link to={HomePath + "/shop"} state={asics[0]?.brand}>
            <div className="h-64 w-64 md:w-96 md:h-96 relative flex items-center justify-center">
                <div className="bg-black absolute h-full w-full opacity-70" />
                <img className="h-full w-full object-cover" src={asics[0]?.img} alt="" />
                <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
                    <span className="z-10 text-white font-black text-lg md:text-xl lg:text-2xl xl:text-3xl capitalize">
                        {asics[0]?.brand}
                    </span>
                </div>
                </div>
            </Link>
            {/* athletix */}
            <Link to={HomePath + "/shop"} state={athletix[0]?.brand}>
            <div className="h-64 w-64 md:w-96 md:h-96 relative flex items-center justify-center">
                <div className="bg-black absolute h-full w-full opacity-70" />
                <img className="h-full w-full object-cover" src={athletix[0]?.img} alt="" />
                <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
                    <span className="z-10 text-white font-black text-lg md:text-xl lg:text-2xl xl:text-3xl capitalize">
                        {athletix[0]?.brand}
                    </span>
                </div>
                </div>
            </Link>
            {/* puma */}
            <Link to={HomePath + "/shop"} state={champion[0]?.brand}>
            <div className="h-64 w-64 md:w-96 md:h-96 relative flex items-center justify-center">
                <div className="bg-black absolute h-full w-full opacity-70" />
                <img className="h-full w-full object-cover" src={champion[0]?.img} alt="" />
                <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
                    <span className="z-10 text-white font-black text-lg md:text-xl lg:text-2xl xl:text-3xl capitalize">
                        {champion[0]?.brand}
                    </span>
                </div>
                </div>
            </Link>
            {/* adidas */}
            <Link to={HomePath + "/shop"} state={adidas[0]?.brand}>
            <div className="h-64 w-64 md:w-96 md:h-96 relative flex items-center justify-center">
                <div className="bg-black absolute h-full w-full opacity-70" />
                <img className="h-full w-full object-cover" src={adidas[0]?.img} alt="" />
                <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
                    <span className="z-10 text-white font-black text-lg md:text-xl lg:text-2xl xl:text-3xl capitalize">
                        {adidas[0]?.brand}
                    </span>
                </div>
                </div>
            </Link>
            {/* jordan */}
            <Link to={HomePath + "/shop"} state={jordan[0]?.brand}>
            <div className="h-64 w-64 md:w-96 md:h-96 relative flex items-center justify-center">
                <div className="bg-black absolute h-full w-full opacity-70" />
                <img className="h-full w-full object-cover" src={jordan[0]?.img} alt="" />
                <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
                    <span className="z-10 text-white font-black text-lg md:text-xl lg:text-2xl xl:text-3xl capitalize">
                        {jordan[0]?.brand}
                    </span>
                </div>
                </div>
            </Link>
        </div>

    </section>
  )
}
